// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AristaIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 256 256">
    <path
      fill="currentColor"
      d="M110.56 52.93C103.4 64.11 8 213.5 8 213.5h33.85l31.8-50.81h67.68l17.44-27.44h-67.7L128 76.3l86.15 136.18H248S153.64 65.12 145.43 51.9c-9.23-13.2-25.64-12.2-34.87 1.02"
    />
  </svg>,
  "Arista",
);
export default AristaIcon;
